export const REACTIONS = ["\u2764\ufe0f", "\uD83D\uDD25", "\uD83C\uDFB5", "\uD83D\uDE0D", "\uD83D\uDC4F"];

export const PICKER_EMOJIS = [
  "\uD83D\uDE0D", "\u2764\ufe0f", "\uD83D\uDD25", "\uD83C\uDFB5", "\uD83C\uDFB6",
  "\u2728", "\uD83D\uDE4C", "\uD83D\uDC4F", "\uD83D\uDCAB", "\uD83E\uDD79",
  "\uD83D\uDE2D", "\uD83E\uDD0D", "\uD83C\uDFA4", "\uD83D\uDC83", "\uD83D\uDD7A",
  "\uD83C\uDF19", "\uD83D\uDE18", "\uD83D\uDE4F", "\uD83D\uDC96", "\uD83C\uDF1F",
];

const PSEUDO_COLORS = [
  "#E0A94B", "#7FB3D5", "#C39BD3", "#76D7C4", "#F1948A",
  "#F7DC6F", "#85C1E9", "#F0B27A", "#82E0AA", "#F5B7B1",
];

export const timeStr = (iso) => {
  try {
    return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
};

export const colorFor = (name) => {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) & 0xffff;
  return PSEUDO_COLORS[h % PSEUDO_COLORS.length];
};

export const initialOf = (name) => (name || "?").trim().charAt(0).toUpperCase();

export const loadMyReactions = () => {
  try {
    return JSON.parse(localStorage.getItem("aka_reactions") || "{}");
  } catch {
    return {};
  }
};
